var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"value-key":"orgName","fetch-suggestions":_vm.search,"clearable":""}},'el-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }